import { Field, FieldType } from '@/types/fields';

export const fieldsToEmptyObject = <T extends object>(fields: ReadonlyArray<Field<T>>): T => {
  return fields.reduce((object: T, field: Field<T>): T => {
    if (field.type === FieldType.embedded) {
      const defaultValue = getDefaultValue(field) as object;
      return { ...object, ...defaultValue };
    } else {
      return {
        ...object,
        [field.name]: getDefaultValue(field),
      };
    }
  }, {} as T);
};

const getDefaultValue = <T extends object>(field: Field<T>): unknown => {
  switch (field.type) {
    case FieldType.boolean:
      return false;
    case FieldType.text:
    case FieldType.email:
    case FieldType.paragraph:
    case FieldType.phoneNumber:
    case FieldType.file:
    case FieldType.select:
    case FieldType.numeric:
    case FieldType.cnpj:
    case FieldType.date:
      return null;
    case FieldType.composite:
    case FieldType.embedded:
      return fieldsToEmptyObject(field.fields);
    case FieldType.list:
    case FieldType.multipleValues:
      return [];
  }
};
